import React from 'react';
import Slider from "react-slick";
import Box from '@material-ui/core/Box';
import Icon from '@material-ui/core/Icon';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Anuncio from '../Anuncio/Anuncio';
import { proccessAdInfo, shuffleArray } from '../../helpers';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./Carousel.css"
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
    SliderHead: {
        display: 'flex',
        justifyContent: 'space-between',
        marginBottom: theme.spacing(2.5)
    },
    SliderTitle: {
        fontWeight: 500,
        display: 'block',
        width: '100%',
        marginBottom: theme.spacing(2)   
    },
    SliderActionWrapper : {
        flexShrink: 0
    },
    nextArrow: {
        fontSize: "0",
        lineHeight: "0",
        position: "absolute",
        top: "50%",
        display: "block",
        width: "40px",
        height: "40px",
        padding: "0",
        transform: "translate(0, -50%)",
        cursor: "pointer",
        color: "#0000008a",
        border: "none",
        outline: "none",
        background: "#fff8f8a1",
        right: "-20px",
        zIndex: "2",
        borderRadius: "100%",
        '&:hover': {
            background: "#fff"
        }
    },

    prevArrow: {
        fontSize: "0",
        lineHeight: "0",
        position: "absolute",
        top: "50%",
        display: "block",
        width: "40px",
        height: "40px",
        padding: "0",
        transform: "translate(0, -50%)",
        cursor: "pointer",
        color: "#0000008a",
        border: "none",
        outline: "none",
        background: "#fff8f8a1",
        left: "-20px",
        zIndex: "2",
        borderRadius: "100%",
        '&:hover':
            { background: "#fff" }
    },
    arrowIcon: {
        fontSize: '40px'
    }
}))

const CustomNextArrow = (props) => {
    const styles = useStyles();
    const { onClick } = props;
    return (        
        <IconButton className={styles.nextArrow} onClick={onClick} disabled={props.currentSlide === props.slideCount - 1}>
            <Icon className={styles.arrowIcon}>navigate_next</Icon>
        </IconButton>      
    );
}

const CustomPrevArrow = (props) => {
    const styles = useStyles();
    const { onClick } = props;    
    return (        
        <IconButton className={styles.prevArrow} onClick={onClick} disabled={props.currentSlide === 0}>
            <Icon className={styles.arrowIcon}>navigate_before</Icon>
        </IconButton>        
    );
}

export default function ItemCarousel(props) {    
    const classes = useStyles();
    const settings = {
        dots: false,
        infinite: false,
        speed: 500,             
        slidesToScroll: 1,        
        variableWidth: true,
        slidesToShow: 1,
        nextArrow: <CustomNextArrow props={props} />,
        prevArrow: <CustomPrevArrow props={props} />        
    };
    
    const createSlider = items => {
        let sldrItems = shuffleArray(items.concat())
        if (items.length > 12)
            sldrItems = sldrItems.slice(0,12);

        return (   
            <React.Fragment>
                { props.title 
                ?   <Box className={classes.SliderHead}>
                        <Typography variant='h5' className={classes.Title}>{props.title}</Typography>                    
                        { props.action && props.action.link && props.action.text
                            ? <div className={classes.SliderActionWrapper}>
                                <Button href={props.action.link} target="_blank">{props.action.text}</Button>
                            </div>
                            : null
                        }
                    </Box>                 
                :   null                 
                }
                <Slider {...settings}>
                    { sldrItems.map((item, index) => {                    
                        return (
                            <Anuncio variant={props.itemVariant} key={`adItem-${index}`} content={proccessAdInfo(item)} />
                            )
                        })
                    }                
                </Slider>
            </React.Fragment>        
        ) 
    }    

    const sldr = props.items && props.items.length > 0 ? createSlider(props.items) : null;

    return sldr;
}